import {GetNotificationsV2Response} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/notification_center/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {SPACING, Text} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {NotificationCardList} from './NotificationCardList';
import {NotificationCenterEmptyState} from './NotificationCenterEmptyState';

export const NotificationCenterContent: React.FC<{
  notifications: GetNotificationsV2Response['notifications'];
  topBodyContent?: React.ReactNode;
}> = ({notifications, topBodyContent}) => {
  const {t} = useTranslation();
  const disableFooter = notifications.length === 0;

  return (
    <BodyContent>
      {topBodyContent}
      <NotificationsStreamWrapper $isStreamEmpty={disableFooter}>
        {notifications.length === 0 ? (
          <NotificationCenterEmptyState
            title={t("You're all caught up!")}
            subtitle={
              <>
                {t(
                  'After few days your notifications will be deleted automatically.',
                )}
                &nbsp;
                {t("We'll notify you once we have something for you.")}
              </>
            }
          />
        ) : (
          <NotificationCardList notifications={notifications} />
        )}
      </NotificationsStreamWrapper>
      {!disableFooter && (
        <FooterText data-testid="notificationCenter-footer">
          <Text color="Grey1" size="px12">
            {t("You've reached the end!")}
          </Text>
          <Text color="Grey1" size="px12">
            {t(
              'After few days your notifications will be deleted automatically.',
            )}
          </Text>
        </FooterText>
      )}
    </BodyContent>
  );
};

const BodyContent = styled.div`
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: ${SPACING['Y.Lg']} ${SPACING['X.Lg']};
`;

const NotificationsStreamWrapper = styled.div<{$isStreamEmpty: boolean}>`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({$isStreamEmpty}) =>
    $isStreamEmpty &&
    css`
      height: 100%;
    `}
`;

const FooterText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 18px;
  text-align: center;
  margin-top: ${SPACING['Y.Xl3']};
  padding-bottom: 72px;
`;
